import { useRatingFeedbackSuccess } from '~/hooks/useRatingFeedbackSuccess';
import { IJob } from '~/models';
import { RatingSentSuccessPopup } from '../RatingSentSuccessPopup';

interface IRatingFeedbackSuccessHandlerProps {
  averageRating: number;
  job: IJob;
  isTriggered: boolean;
  onSubmitFeedback: (showMessage?: boolean) => void;
}

export const RatingFeedbackSuccessHandler = ({
  averageRating,
  job,
  isTriggered,
  onSubmitFeedback,
}: IRatingFeedbackSuccessHandlerProps) => {
  const {
    shouldShowRatingSentPopup,
    eligibleJobs,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoadingEligibleJobs,
    handleCloseRatingSentPopup,
  } = useRatingFeedbackSuccess({
    averageRating,
    job,
    shouldCheckConditions: isTriggered,
    onSubmitFeedback,
  });

  if (!shouldShowRatingSentPopup) {
    return null;
  }

  return (
    <RatingSentSuccessPopup
      eligibleJobs={eligibleJobs}
      professional={job?.offer_final_reciever}
      officeId={job?.offer_owner?.id}
      onClose={handleCloseRatingSentPopup}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      isLoading={isLoadingEligibleJobs}
      onSubmitFeedback={() => onSubmitFeedback(false)}
    />
  );
};
